// FNP-1675: the same business-record fields the queries select.
const APPLICATION_RESPONSE_FIELDS = `
    id
    name
    description
    url
    logoUrl
    applicationCategory
    applicationStatus
    displayName
    tags { key value }
    created
    updated
`;

export const createApplication = `
    mutation createApplication($input: CreateApplicationInput!) {
        createApplication(input:$input) {
            ${APPLICATION_RESPONSE_FIELDS}
    }
}`;

export const updateApplication = `
    mutation updateApplication($input: UpdateApplicationInput!) {
        updateApplication(input:$input){
            ${APPLICATION_RESPONSE_FIELDS}
        }
}`;

export const deleteApplication = `
    mutation deleteApplication($input: DeleteApplicationInput!) {
        deleteApplication(input:$input) {
            id
        }

}`;
